/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.js
 * @description EducationalCategory Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { educationalMaterial: educationalCategoryEndpoints } = endpoints;

export class EducationalCategoryService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get educationalCategories list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get educationalCategories list.
   */
  getEducationalCategories = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = `${educationalCategoryEndpoints.category}/listEducationCategory`;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get educationalCategory info by id
   * @param { string } id - EducationalCategory id.
   * @return { Object } - Get educationalCategories list.
   */
  getEducationalCategoryById = async (id) => {
    const url = `${educationalCategoryEndpoints.category}/${id}`;
    return this.http.get(url);
  };

  /**
   * Create educationalCategory
   * @param { string } name - EducationalCategory name.
   * @param { string } description - EducationalCategory description.
   * @param { object } parent - EducationalCategory parent object.
   * @return { promise } - The educationalCategory promise object.
   */
  createEducationalCategory = async (name, description, parent) => {
    const body = { name, description, parent };
    const url = educationalCategoryEndpoints.category;
    return this.http.post(url, body);
  };

  /**
   * Delete educationalCategory by id
   * @param { string } id - EducationalCategory id.
   * @return { Object } - Get educationalCategories list.
   */
  deleteEducationalCategoryById = async (id) => {
    const url = `${educationalCategoryEndpoints.category}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update educationalCategory
   * @param { string } name - EducationalCategory name.
   * @param { string } description - EducationalCategory description.
   * @param { string } id - EducationalCategory id.
   * @return { promise } - The educationalCategory promise object.
   */
  updateEducationalCategory = async (
    id_education_category,
    name,
    description,
    parent,
    id
  ) => {
    const body = { id_education_category, name, description, parent };
    const url = `${educationalCategoryEndpoints.category}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new EducationalCategoryService(externalConnector);
